import React from 'react';

import { Icon } from '../SvgImage';

import { SOCIAL_COLORS } from './constants';
import { SocialIconProps } from './types';

const SocialIcon: React.FC<SocialIconProps> = props => {
  const { image, ...rest } = props;

  return <Icon {...rest} image={image} color={SOCIAL_COLORS[image]} />;
};

export default SocialIcon;
